import React, { useState, useEffect, useLayoutEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ResetPassword from './components/ResetPassword';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Yüklenme durumu ekle

  useEffect(() => {
    // Önce localStorage'a bak (Beni Hatırla), yoksa sessionStorage'a bak
    const storedUser = localStorage.getItem('user') || sessionStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false); // Kontrol bitti
  }, []);

  // SAAS GÜVENLİK YAMASI: Axios Interceptor
  // useLayoutEffect kullanarak alt bileşenler (Home, Patients vb.) veri çekmeden ÖNCE
  // clinic_id'nin header/params'a eklendiğinden emin oluyoruz.
  useLayoutEffect(() => {
    const interceptor = axios.interceptors.request.use(config => {
        if (user && user.clinic_id) {
            config.params = { ...config.params, clinic_id: user.clinic_id };
        }
        return config;
    });
    return () => axios.interceptors.request.eject(interceptor);
  }, [user]);

  const handleLogin = (userData, rememberMe) => {
    setUser(userData);
    if (rememberMe) {
      localStorage.setItem('user', JSON.stringify(userData));
    } else {
      sessionStorage.setItem('user', JSON.stringify(userData));
    }
  };

  const handleUpdateUser = (updatedUserData) => {
    setUser(updatedUserData);
    if (localStorage.getItem('user')) {
        localStorage.setItem('user', JSON.stringify(updatedUserData));
    } else if (sessionStorage.getItem('user')) {
        sessionStorage.setItem('user', JSON.stringify(updatedUserData));
    }
  };

  const handleLogout = () => {
    // Çıkış yaparken kullanıcının sekme geçmişini temizle
    if (user && user.id) {
        localStorage.removeItem(`dentis_tabs_${user.id}`);
        localStorage.removeItem(`dentis_active_tab_${user.id}`);
    }
    setUser(null);
    localStorage.removeItem('user');
    sessionStorage.removeItem('user');
  };

  if (loading) return null; // Veya <div>Yükleniyor...</div>

  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover closeButton={false} />
      <Routes>
        <Route path="/login" element={!user ? <Login onLogin={handleLogin} /> : <Navigate to="/dashboard" />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/dashboard" element={user ? <Dashboard user={user} onLogout={handleLogout} onUpdateUser={handleUpdateUser} /> : <Navigate to="/login" />} />
        <Route path="*" element={<Navigate to={user ? "/dashboard" : "/login"} />} />
      </Routes>
    </Router>
  );
}

export default App;